import LogoImg from "@/../../public/images/pelorus-logo.svg";
import Welcomeback from "@/../../public/images/welcomeback.svg";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import AuthFooterScreen from "../../../component/layout/authfooter";

import { CiUser } from "react-icons/ci";
import { TbUserScan } from "react-icons/tb";
import { IoKeyOutline } from "react-icons/io5";
import { LuBuilding2 } from "react-icons/lu";

import { useEffect, useState } from "react";
import {
  useCustomNavigate,
  useCurrentURL,
} from "../../../hooks/useCustomNavigate";
import { AppRoute } from "../../../router/routerConstants";
import * as yup from "yup";
import { useLocation } from "react-router-dom";
import { useFormik } from "formik";
import { ValidationCons } from "../../../validation/validationConstant";

const RegisterScreen = () => {
  const [NavigateTo] = useCustomNavigate();
  const { state } = useLocation();
  const location = useLocation();
  const empFormUrl = location.pathname.split("/")[1];
  const [currentUrl] = useCurrentURL();
  const [isJobSeekerRegister, setIsJobSeekerRegister] = useState(false);
  const { jobId } = location?.state || {}; // Access the passed state

  useEffect(() => {
    if (currentUrl.includes("jobs/jobs-register")) {
      setIsJobSeekerRegister(true);
    } else {
      setIsJobSeekerRegister(false);
    }
  }, [currentUrl]);

  const registerAccountFormik = useFormik({
    initialValues: {
      firstName: state?.firstName || "",
      lastName: state?.lastName || "",
      emailAddress: state?.emailAddress || "",
    },
    validationSchema: yup.object({
      firstName: yup
        .string()
        .trim()
        .required(ValidationCons.FIRST_NAME_REQUIRED),
      lastName: yup.string().trim().required(ValidationCons.LAST_NAME_REQUIRED),
      emailAddress: yup
        .string()
        .email(ValidationCons.IS_EMAIL)
        .required(ValidationCons.EMAIL_REQUIRED),
    }),
    onSubmit: async (values: any) => {
      let userType = "";
      if (isJobSeekerRegister) {
        userType = "jobseeker";
      } else {
        if (currentUrl.includes("agent/register")) {
          userType = "localagents";
        } else if (currentUrl.includes("emp/register")) {
          userType = "employer";
        }
      }

      const states = {
        firstName: values.firstName,
        lastName: values.lastName,
        emailAddress: values.emailAddress,
        role: userType,
        password: state?.password,
        cnfPassword: state?.cnfPassword,
        jobId: jobId,
      };
      if (empFormUrl === "emp") {
        NavigateTo(AppRoute.EMPLOYEE_REGISTER_STEP2, false, states);
      } else {
        NavigateTo(AppRoute.AGENT_REGISTER_STEP2, false, states);
      }
    },
  });

  return (
    <>
      <header className="header common-padd-lt-rt common-padd-small pb-0">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="logo text-left">
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a onClick={() => NavigateTo(AppRoute.SPLASH)}>
                  <img src={LogoImg} alt="logo" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </header>

      <div className="main-authModule">
        <section className="welcomebodylogin common-padd-small">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6 leftlargeImg">
                <img src={Welcomeback} alt="logo"/>
              </div>
              <div className="col-lg-6">
                <div className="welcome-holder">
                  <h1>Create an Account</h1>
                  <p>
                    Enter your personal details to create an account and start
                    journey with us.
                  </p>
                  <div className="login-form-area registerform">
                    <Form onSubmit={registerAccountFormik.handleSubmit}>
                      <div className="stepbar">
                        <ul>
                          <li className="inprogress">
                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                            <a>
                              <div className="icon-progress">
                                <span>
                                  <CiUser />
                                </span>
                              </div>
                              <p>Step 1</p>
                              <h4>Personal Info</h4>
                            </a>
                          </li>
                          <li className="">
                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                            <a>
                              <div className="icon-progress">
                                <span>
                                  <IoKeyOutline />
                                </span>
                              </div>
                              <p>Step 2</p>
                              <h4>Password</h4>
                            </a>
                          </li>
                          <li className="">
                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                            <a>
                              <div className="icon-progress">
                                <span>
                                  <TbUserScan />
                                </span>
                              </div>
                              <p>Step 3</p>
                              <h4>Verification</h4>
                            </a>
                          </li>
                          {!isJobSeekerRegister && (
                            <li className="">
                              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                              <a>
                                <div className="icon-progress">
                                  <span>
                                    <LuBuilding2 />
                                  </span>
                                </div>
                                <p>Step 4</p>
                                <h4>
                                  {empFormUrl === "emp"
                                    ? "Company Info"
                                    : "Agent Info"}
                                </h4>
                              </a>
                            </li>
                          )}
                        </ul>
                      </div>
                      <h3>Add Personal Info</h3>
                      <Form.Group
                        className="mb-3"
                        controlId="formBasicfirstname"
                      >
                        <Form.Label>First Name</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter your first name"
                          name="firstName"
                          onChange={registerAccountFormik.handleChange}
                          onBlur={registerAccountFormik.handleBlur}
                          value={registerAccountFormik.values.firstName}
                          isInvalid={
                            !!registerAccountFormik.errors.firstName &&
                            Boolean(registerAccountFormik.touched.firstName)
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {typeof registerAccountFormik.errors.firstName ===
                            "string" && registerAccountFormik.errors.firstName}
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group
                        className="mb-3"
                        controlId="formBasiclastname"
                      >
                        <Form.Label>Last Name</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter your last name"
                          name="lastName"
                          onChange={registerAccountFormik.handleChange}
                          onBlur={registerAccountFormik.handleBlur}
                          value={registerAccountFormik.values.lastName}
                          isInvalid={
                            !!registerAccountFormik.errors.lastName &&
                            Boolean(registerAccountFormik.touched.lastName)
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {typeof registerAccountFormik.errors.lastName ===
                            "string" && registerAccountFormik.errors.lastName}
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Email Address</Form.Label>
                        <Form.Control
                          type="email"
                          placeholder="Enter your email address"
                          name="emailAddress"
                          onChange={registerAccountFormik.handleChange}
                          onBlur={registerAccountFormik.handleBlur}
                          value={registerAccountFormik.values.emailAddress}
                          isInvalid={
                            !!registerAccountFormik.errors.emailAddress &&
                            Boolean(registerAccountFormik.touched.emailAddress)
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {typeof registerAccountFormik.errors.emailAddress ===
                            "string" &&
                            registerAccountFormik.errors.emailAddress}
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Button
                        className="btn w-100 btn-primary"
                        variant="primary"
                        type="submit"
                      >
                        Next
                      </Button>
                    </Form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <AuthFooterScreen />
    </>
  );
};
export default RegisterScreen;
